import styled from 'styled-components';

export const PageWrapper = styled.div`
  display: grid;
  grid-template-rows: 70px 74px 1fr;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.fundo};
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
`;

export const GovLogoImg = styled.img`
  width: 75px;
  height: auto;
  object-fit: contain;
  margin-left: 45px;
`;

export const MedsusLogoImg = styled.img`
  width: 70px;
  height: 2.5rem;
  object-fit: contain;
`;

export const HeaderTitle = styled.h1`
  color: ${({ theme }) =>
    theme.colors.medsusPublic.textoBannerInfo || '#707070'};
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  margin-left: 0;
`;

export const HeaderNav = styled.nav`
  display: flex;
  align-items: center;
  gap: 50px;
`;

export const RestrictedAreaButton = styled.button`
  background-color: ${({ theme }) => theme.colors.verdegov};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  padding: 0;
  width: 206px;
  height: 38px;
  border-radius: 15px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  /* margin-right: 10px; */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    filter: brightness(0.85);
    box-shadow: 0 4px 12px rgba(22, 136, 33, 0.3);
  }

  &:active {
    filter: brightness(0.75);
  }
`;

export const InfoBanner = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) =>
    theme.colors.medsusPublic.fundoBannerInfo || '#E1ECFE'};
  padding: 0 40px;
`;

export const BannerText = styled.p`
  color: ${({ theme }) =>
    theme.colors.medsusPublic.textoBannerInfo || '#707070'};
  font-size: 18px;
  text-align: center;
  margin: 0;
  line-height: 1.5;
`;

export const TableContainer = styled.section`
  overflow-y: auto;
  padding: 30px 40px;
  /* background-color: ${({ theme }) =>
    theme.colors.medsusPublic.fundoTabela || '#FFFFFF'}; */
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 20px;
`;

export const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 20px;
  padding: 40px;
  text-align: center;
`;

export const ErrorText = styled.p`
  color: ${({ theme }) =>
    theme.colors.medsusPublic.textoBannerInfo || '#707070'};
  font-size: 16px;
  margin: 0;
`;

export const RetryButton = styled.button`
  background-color: ${({ theme }) =>
    theme.colors.medsusPublic.botaoAzul || '#1868E6'};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  padding: 10px 20px;
  border-radius: 15px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(19, 81, 180, 0.3);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const VerticalDivider = styled.div`
  width: 0;
  height: 50px;
  border: 1px solid ${({ theme }) => theme.colors.cinza || '#ADBBCF'};
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 42px;
  margin-right: 20px;
`;

export const VerticalDividerSmall = styled.div`
  width: 0;
  height: 15px;
  border: 1px solid ${({ theme }) => theme.colors.cinza || '#ADBBCF'};
  margin-left: 20px;
  margin-right: 20px;
`;

export const MedicamentosLink = styled.a`
  color: ${({ theme }) => theme.colors.textoAzul || '#1868E6'};
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  line-height: 1.33;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }

  &:active {
    opacity: 0.6;
  }
`;

export const NavigationIconButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.amarelogov};
  font-size: 18px;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    color: ${({ theme }) => theme.colors.amarelogov};
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const DetailPageWrapper = styled.div`
  display: grid;
  grid-template-rows: 70px 74px 1fr;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.fundo};
`;

export const DetailHeader = styled.header`
  display: flex;
  align-items: center;
  padding: 20px 40px;
  background-color: ${({ theme }) =>
    theme.colors.medsusPublic.fundoBannerInfo || '#E1ECFE'};
  gap: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) =>
    theme.colors.medsusPublic.textoBannerInfo || '#707070'};
  font-size: 24px;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const DetailTitle = styled.h1`
  color: ${({ theme }) =>
    theme.colors.medsusPublic.textoBannerInfo || '#707070'};
  font-size: 20px;
  font-weight: 600;
  margin: 0;
`;

export const DetailContent = styled.section`
  overflow-y: auto;
  padding: 30px 40px;
`;

export const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid ${({ theme }) => theme.colors.fundo};
  border-top: 4px solid ${({ theme }) => theme.colors.azulgov};
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const EmptyVmpMessage = styled.p`
  color: ${({ theme }) => theme.colors.cinzaEscuro};
  font-size: 16px;
  text-align: center;
  padding: 40px;
  margin: 0;
`;
